import { Box, Modal, Stack, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import styles from "../../../styles/modal/login.module.css";
import classes from "../../../styles/pujaMainCard.module.css";
import NavBar from "../NavBar";
import { useTranslation } from "react-i18next";
import { useRouter } from "next/router";
import RegistrationStepper from "../registrationStepper";
import PujaBookingDetailsCard from "../pujaBookingDetailsCard";
import { useDispatch, useSelector } from "react-redux";
import { AUTH_TYPE, LANGUAGE, SMS_TEMPLATE, WEB_ENGAGE } from "@utils/constants";
import { trackEvent, trackPeopleAuth, trackUserAttributes } from "@utils/analytics/event-analytics";
import UtsavTextField from "src/globalModule/components/UtsavTextField";
import Image from "next/legacy/image";
import { Store } from "@utils/store/ContextStore";
import theme from "src/globalModule/styles/theme";
import RegistrationBtn from "../registrationBtn";
import approverImage from "../../../../../public/assets/newEvent/pujaDetails/approver.webp";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { setUserData } from "@utils/reduxToolkit/features/userSlice";
import { setHeaderAccessToken } from "@utils/api/axiosInstance";
import { getEncryptedCookieUserData } from "@utils/cookie/cookies";
import { addRegistrationDetails } from "@utils/reduxToolkit/features/registrationDetailsSlice";
import { useCookies } from "react-cookie";
import Cookies from "js-cookie";
import { eventRegistration } from "src/pujaModule/queries/pujas.queries";
import { updatePujaAmount } from "@utils/reduxToolkit/features/cartSlice";
import { domain } from "@utils/BASE-URL";
function RegistrationLogin({
  showLoginModal,
  setShowLoginModal,
  setShowBhetModal
}) {
  //   const [openLogin, setOpenLogin] = useState(true);
  const router = useRouter();
  const {
    eventid
  } = router.query;
  const {
    t
  } = useTranslation();
  const {
    state
  } = useContext(Store);
  const loggedInUser = state.user;
  const dispatch = useDispatch();
  const {
    dispatch: storeDispatch
  } = useContext(Store);
  const [, setCookie] = useCookies([]);
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isBharatAgri, setIsBharatAgri] = useState(false);
  const {
    subEventDetails
  } = useSelector(state => state.subEventDetails);
  const [errorModal, setErrorModal] = useState({
    open: false,
    heading: "",
    message: "",
    acceptMethod: () => {},
    icon: null
  });

  /* Start - Varaible for Main Registration Card */
  const [name, setName] = useState("");
  const [contact, setContact] = useState("");
  const [nameError, setNameError] = useState(false);
  const [contactError, setContactError] = useState(false);
  /* End - Varaible for Main Registration Card */

  const handleCloseLogin = () => {
    setShowLoginModal(false);
  };
  useEffect(() => {
    trackEvent(WEB_ENGAGE.SCREEN_NAMES.EVENT_REGISTRATION_MAIN_CARD + " " + WEB_ENGAGE.EVENT_NAMES.SCREEN_VIEWED, {
      [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EVENT_REGISTRATION_MAIN_CARD,
      [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]: subEventDetails?.eventName_WE,
      [WEB_ENGAGE.EVENT_PROPERTIES.SUB_KRIYA_NAME]: subEventDetails?.name_WE,
      [WEB_ENGAGE.EVENT_PROPERTIES.AMOUNT]: Number(subEventDetails?.eventRegistrationAmount),
      [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_DEITY_TYPE]: subEventDetails?.deityName,
      [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_URL_EXTENSION]: eventid,
      [WEB_ENGAGE.EVENT_PROPERTIES.SUB_EVENT_URL_EXTENSION]: subEventDetails?.urlExtension
    });
  }, []);
  useEffect(() => {
    if (router.query.utm_source === "bharat_agri") {
      setIsBharatAgri(true);
    }
  }, [router.query]);
  useEffect(() => {
    if (loggedInUser && loggedInUser?.authType !== null) {
      setName(loggedInUser?.name);
      if (loggedInUser?.authType === AUTH_TYPE.PHONE) setContact(loggedInUser?.authID.slice(-10));
    }
  }, [loggedInUser]);
  const handleNameChange = e => {
    const value = e.target.value;
    const regex1 = /[`~!@#$%^&*()_|+\-=?;:'".,<>\{\}\[\]\\\/0-9]/gi;
    if (regex1.test(value)) {
      return;
    }
    setName(value);
    const regex = /^$|^[a-zA-Z. ]+(([', -][a-zA-Z ])?[a-zA-Z ]*)*$/;
    if (e.target.validity.valid && regex.test(value)) {
      setNameError(false);
    }
  };
  const handleNumberChange = e => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/\D/g, "");
    inputValue = inputValue?.replace(/^\+91-/, "")?.replace(/^\+91/, "")?.replace(/^0-/, "")?.replace(/^0/, "")?.replace(" ", "")?.replace("-", "");
    if (e.target.validity.valid && inputValue?.length === 10) {
      setContactError(false);
    }
    if (inputValue?.length > 10) {
      return;
    }
    setContact(inputValue);
  };
  const onSubmitHandler = async e => {
    e.preventDefault();
    setLoading(true);
    trackEvent(WEB_ENGAGE.SCREEN_NAMES.EVENT_REGISTRATION_MAIN_CARD + " " + WEB_ENGAGE.BUTTON_NAMES.POSITIVE + " " + WEB_ENGAGE.EVENT_NAMES.BUTTON_CLICKED, {
      [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EVENT_REGISTRATION_MAIN_CARD,
      [WEB_ENGAGE.EVENT_PROPERTIES.BUTTON_NAME]: WEB_ENGAGE.BUTTON_NAMES.POSITIVE,
      [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]: subEventDetails?.eventName_WE,
      [WEB_ENGAGE.EVENT_PROPERTIES.SUB_KRIYA_NAME]: subEventDetails?.name_WE,
      [WEB_ENGAGE.EVENT_PROPERTIES.AMOUNT]: Number(subEventDetails?.eventRegistrationAmount),
      [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_DEITY_TYPE]: subEventDetails?.deityName,
      [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_URL_EXTENSION]: eventid,
      [WEB_ENGAGE.EVENT_PROPERTIES.SUB_EVENT_URL_EXTENSION]: subEventDetails?.urlExtension
    });
    if (!e.target.checkValidity()) {
      const formElements = e.target.elements;
      let invalidField = null;
      for (let i = 0; i < formElements.length; i++) {
        if (!formElements[i].validity.valid) {
          invalidField = formElements[i].name;
          if (invalidField === "Name") {
            setNameError(true);
          } else if (invalidField === "Contact") {
            setContactError(true);
          }
          break;
        }
      }
      setLoading(false);
      return;
    }
    if (!name || !contact) {
      setErrorModal({
        open: true,
        heading: `${t("puja-registration")}`,
        message: `${t("please-fill-all-the-fields")}`,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <ErrorOutlineOutlinedIcon sx={{
          fontSize: "3rem",
          color: "red"
        }} />
      });
      return () => {};
    }
    const res = await dummyRegistration();

    // console.log("Dummy Registration Response", res);

    if (res && res.success) {
      let obj = {
        ...res?.response,
        page: 3
      };
      if (!loggedInUser.accessToken) {
        // sendOTPHandler();
        dispatch(setUserData({
          userData: {
            name: res.response?.user?.name,
            uid: res.response?.user?.uid,
            authType: res.response?.userAuth?.authType,
            accessToken: res.response?.userAuth?.accessToken,
            role: res.response?.userRole
          },
          lang: res.response?.user?.UserDetail.language
        }));
        setHeaderAccessToken(res.response.userAuth?.accessToken);
        let lang = res.response?.user?.UserDetail?.language;
        if (lang === null) {
          lang = LANGUAGE.ENGLISH;
        }
        const userData = {
          ...res.response?.userAuth,
          ...res.response?.user,
          ...res.response?.userRole
        };
        storeDispatch({
          type: "SET_DATA",
          payload: {
            userData,
            lang
          }
        });
        const object = getEncryptedCookieUserData({
          data: res.response?.userAuth,
          user: res.response?.user,
          userRole: res.response?.userRole
        });
        let encryptedUserData = null,
          encryptedUser = null;
        if (object) {
          encryptedUser = object.encryptedUser;
          encryptedUserData = object.encryptedUserData;
        }
        setCookie("utsavUser", encryptedUser, {
          path: "/",
          secure: true,
          sameSite: "none",
          domain: domain,
          maxAge: 60 * 60 * 24 * 7 //7-days
        });
        setCookie("utsavData", encryptedUserData, {
          path: "/",
          secure: true,
          sameSite: "none",
          domain: domain,
          maxAge: 60 * 60 * 24 * 7 //7-days
        });
      }
      dispatch(addRegistrationDetails(obj));
      setLoading(false);
      setShowBhetModal(true);
      setShowLoginModal(false);
    }
  };
  const dummyRegistration = async () => {
    let getCookieObj = Cookies.get("eventCookie");
    if (getCookieObj) {
      getCookieObj = JSON.parse(getCookieObj);
      Cookies.remove("eventCookie");
    }
    const res = await eventRegistration({
      eventID: subEventDetails.eventID,
      name: name,
      contact: contact,
      subEventID: subEventDetails.subEventID,
      costPrice: subEventDetails.pujaCostPrice,
      sellingPrice: subEventDetails.eventRegistrationAmount,
      referrerID: getCookieObj?.referrerID || null,
      utm_source: getCookieObj?.utm_source || null,
      utm_medium: getCookieObj?.utm_medium || null,
      utm_campaign: getCookieObj?.utm_campaign || null,
      utm_content: getCookieObj?.utm_content || null,
      source: SMS_TEMPLATE.WEBSITE,
      eventStart: subEventDetails.start,
      language: router.locale
    });
    if (res?.success) {
      const userAuth = res.response.userAuth;
      const user = res.response.user;
      trackPeopleAuth(userAuth);
      trackUserAttributes(user);
      if (res?.response?.registrationDetails?.eventRegistrationAmount) {
        dispatch(updatePujaAmount(Number(res?.response?.registrationDetails?.eventRegistrationAmount)));
      } else {
        dispatch(updatePujaAmount(Number(subEventDetails?.eventRegistrationAmount)));
      }
      return res;
    } else {
      setErrorModal({
        open: true,
        heading: `${t("puja-registration")}`,
        message: res?.message ?? `${t("something-went-wrong")}`,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <ErrorOutlineOutlinedIcon sx={{
          fontSize: "3rem",
          color: "red"
        }} />
      });
      return null;
    }
  };
  return <Modal open={showLoginModal} onClose={handleCloseLogin} data-sentry-element="Modal" data-sentry-component="RegistrationLogin" data-sentry-source-file="login.jsx">
      <Box className={styles.modalContainer} data-sentry-element="Box" data-sentry-source-file="login.jsx">
        <NavBar activeStep={activeStep} router={router} name={t("puja-booking")} closeModal={handleCloseLogin} data-sentry-element="NavBar" data-sentry-source-file="login.jsx" />

        <Stack mt={"55px"} data-sentry-element="Stack" data-sentry-source-file="login.jsx">
          <RegistrationStepper activeStep={activeStep} data-sentry-element="RegistrationStepper" data-sentry-source-file="login.jsx" />
          <PujaBookingDetailsCard subEventDetails={subEventDetails} show={false} data-sentry-element="PujaBookingDetailsCard" data-sentry-source-file="login.jsx" />
          <div className={styles.parentContainer}>
            <div className={classes.container}>
              <Box component={"form"} className={classes.registrationDetails} onSubmit={onSubmitHandler} noValidate data-sentry-element="Box" data-sentry-source-file="login.jsx">
                <div>
                  <Typography className={classes.registrationDetailsHeader} data-sentry-element="Typography" data-sentry-source-file="login.jsx">
                    {t("enter-your-name-and-number")}
                  </Typography>
                  <UtsavTextField id="outlined-basic" label={t("enter-your-name")} name="Name" type="text" varient="outlined" value={name} autoComplete="name" setProps={handleNameChange} // setProps
                error={nameError} important={true} data-sentry-element="UtsavTextField" data-sentry-source-file="login.jsx" />
                  <UtsavTextField label={t("enter-phone-number")} name="Contact" type="tel" value={contact} autoComplete="tel" inputProps={{
                  inputMode: "numeric",
                  pattern: "[0-9]*"
                }} setProps={handleNumberChange} // setProps
                startAdornment={"+91"} disabled={loggedInUser?.authType === AUTH_TYPE.PHONE} error={contactError} important={true} data-sentry-element="UtsavTextField" data-sentry-source-file="login.jsx" />
                  <Typography sx={{
                  mt: "10px",
                  color: theme.palette.text.secondaryDark,
                  fontSize: "15px"
                }} data-sentry-element="Typography" data-sentry-source-file="login.jsx">
                    {t("all-puja-update-video-and-prasad-details-will-be-shared-on-your-whatsapp-and-utsav-app")}
                  </Typography>
                </div>
                <div className={classes.bottomContainer}>
                  {isBharatAgri && <div className={classes.approvedContainer}>
                      <Typography className={classes.approvedText}>
                        {t("in-collaboration-with")}
                      </Typography>
                      <Image src={"/assets/newEvent/pujaDetails/brandLogo/BharatAgri.svg"} alt="BharatAgriLogo" height={20} width={100} />
                    </div>}
                  <div className={classes.approvedContainer}>
                    <Typography className={classes.approvedText} data-sentry-element="Typography" data-sentry-source-file="login.jsx">
                      {t("approved-by")}
                    </Typography>
                    <Image src={approverImage} alt="approverImage" height={40} width={300} data-sentry-element="Image" data-sentry-source-file="login.jsx" />
                  </div>
                  <RegistrationBtn btnText={`${t("Next")}`} loading={loading} data-sentry-element="RegistrationBtn" data-sentry-source-file="login.jsx" />
                  {!loggedInUser.accessToken && <div className={classes.policyContainer}>
                      <p className={classes.policy}>
                        {t("by-signing-in-you-agree-to-utsav-and-apos-s-and-nbsp")}
                        <span className={classes.policyPage} onClick={() => window.open("/terms-of-use", "_blank")}>
                          {t("t-and-c-and-nbsp")}
                        </span>{" "}
                        {t("and")}{" "}
                        <span className={classes.policyPage} onClick={() => window.open("/privacy-and-cookie-policy", "_blank")}>
                          {t("privacy-policy")}
                        </span>
                        {router.locale === LANGUAGE.HINDI && t("agree")}
                      </p>
                      <p className={classes.policy}>
                        {t("check-out-our")}{" "}
                        <span className={classes.policyPage} onClick={() => window.open("/refund-policy", "_blank")}>
                          {t("refund-policy")}
                        </span>
                      </p>
                    </div>}
                </div>
              </Box>
            </div>
          </div>
        </Stack>
      </Box>
    </Modal>;
}
export default RegistrationLogin;